// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav___aleS","expandableContainer":"styles_expandableContainer__SXUGq","footerLinksContainer":"styles_footerLinksContainer___qNCC"};